import React, { memo } from 'react/cjs/react.production.min';
import { Row } from 'react-bootstrap';
import LVAnalyseStatusViewComponent from '../Components/AnalystDashboard/LVAnalyseStatusViewComponent';


function LvAnalyseStatusPage(props) {
    return (<>
        <div>
            <br />
            <Row>
                <LVAnalyseStatusViewComponent lvObjectIN={props.location.state.lvObject} />
            </Row>
        </div>
    </>);
}

export default memo(LvAnalyseStatusPage);